import fileUrl from './file-url';

export default function userImageUrl(path?: string | null): string {
  // eslint-disable-next-line global-require
  return path ? fileUrl(path) : require('@/assets/images/default/user.svg');
}
